import { obterUsuariosAsync } from "../../services/usuarioService";

const atualizarUsuarios = async ({ commit }) => {
    const usuarios = await obterUsuariosAsync();
    commit('atualizarUsuarios', usuarios);
}

const atualizarUsuario = ({ commit }, usuario) => {
    commit('atualizarUsuario', usuario);
}

export default {
    atualizarUsuarios,
    atualizarUsuario
}